import { configureStore } from "@reduxjs/toolkit";
 
import contactReducer from '../features/contact/contactSlice';
import bookingReducer from '../features/booking/bookingSlice';
import trackReducer from "../features/track/trackSlice"
import projectReducer from "../features/project/projectSlice"

export const store = configureStore({
  reducer: {
  
     contact:contactReducer,
      booking:bookingReducer,
      track:trackReducer,
     project: projectReducer,
       
   },
});